const REGION_CONFIGS = {
  'en-usd': {
    currency: 'USD',
    currencySymbol: '$',
    language: 'en',
    paymentGateway: 'sumit',
    baseUrl: 'https://tripplannerit.com',
    prices: {
      dailyPrice: 2,
      extraUserPrice: 4,
      whiteLabelPrice: 59,
      firstShareStartingBalance: 20
    }
  },
  'he-ils': {
    currency: 'ILS',
    currencySymbol: '₪',
    language: 'he',
    paymentGateway: 'sumit',
    baseUrl: 'https://tripplanner.co.il',
    prices: {
      dailyPrice: 5,
      extraUserPrice: 10,
      whiteLabelPrice: null,
      firstShareStartingBalance: 50
    }
  }
}

export default REGION_CONFIGS
